import type { IconAsset } from '../Icon.types';

const code = (
  <svg
    data-name='Calque 1'
    fill='#ffc72c'
    id='Calque_1'
    viewBox='0 0 59.1 61.15'
    xmlns='http://www.w3.org/2000/svg'
  >
    <defs>
      <style>.cls-1</style>
    </defs>
    <title>logo-b</title>
    <path
      className='cls-1'
      d='M532.41,439.33c-4.24-2-10.24-1-15.72,1v0c.41-7.53-.75-9.72-.75-9.72l-6.24,1.75a49.88,49.88,0,0,1,.41,11.12h0c-16.22,9.38-27.15,25.08-30.16,35.63-3.28,11.49,5.88,15.4,13.59,9.74,19-14,22.9-45.75,22.9-45.75,5.74-1.75,10.3-.81,13,1.5,6.74,5.81-2,14.73-2,14.73a10.19,10.19,0,0,0-6.52-3c-6.82-.62-10.28,7.57-1.23,8.45a19.49,19.49,0,0,0,7-1.17c1.51,2.8,1.05,15.77-7.7,19.61-7.87,3.45-10.79-1.39-10.79-1.39-.25,0-4.24,5.26-4,5.75,0,0,4.17,6.22,13.31,3.55,7.21-2.1,10.67-8.39,12.52-12.9,3.08-7.51.86-14.13-.33-15.87h0C541.66,453.94,539.91,442.56,532.41,439.33ZM490.9,486.55c-6.66,1.78-4.89-12.84,3.56-24.51,8.62-11.9,15.38-15.47,15.38-15.47C508.38,463.94,498,484.65,490.9,486.55Zm26.77-25.05c-1.93-1.19,0-3,1.76-3,2.88,0,5.5,2.51,5.5,2.51S520,462.9,517.67,461.5Z'
      transform='translate(-479.26 -430.59)'
    />
  </svg>
);

export const breitling: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
